import { arSavGeometria } from './arSav.ts';

export interface ArSavProps {
  /** Az alsó és felső érték (Ft) és a középérték; a szakértői változatnál elhagyható. */
  min?: number; max?: number; kozep?: number;
  /** A közös skála (Ft), hogy a sorok sávjai összehasonlíthatók legyenek (lásd `kozosSkala`). */
  skalaMin?: number; skalaMax?: number;
  /** A sáv alatti felirat (pl. „71–96 millió Ft”); a számot `<b>` jelölheti a hívó. */
  felirat: React.ReactNode;
  /** Szakértői becslés: nincs szám, üres skála és arany felirat. */
  szakerto?: boolean;
}

/** Mini ársáv közös skálán, középérték-jelzővel. */
export default function ArSav({ min, max, kozep, skalaMin, skalaMax, felirat, szakerto = false }: ArSavProps) {
  let jel: React.ReactNode = null;
  if (!szakerto) {
    if (min === undefined || max === undefined || kozep === undefined || skalaMin === undefined || skalaMax === undefined) {
      throw new TypeError('Az ArSav-hoz szakértői változaton kívül min, max, kozep, skalaMin és skalaMax kell.');
    }
    const g = arSavGeometria({ min, max, kozep, skalaMin, skalaMax });
    jel = (
      <>
        <i className="absolute inset-y-0 rounded-[3px]" style={{ left: `${g.balSzazalek}%`, width: `${g.szelessegSzazalek}%`, background: 'var(--sav-atmenet)' }} />
        <u className="absolute -top-[3px] h-3 w-0.5 rounded-[1px] bg-szoveg" style={{ left: `${g.kozepSzazalek}%` }} />
      </>
    );
  }
  return (
    <div className="grid gap-1.5">
      <div className="relative h-1.5 rounded-[3px] bg-felulet" aria-hidden>{jel}</div>
      <span className={`text-sm ${szakerto ? 'text-masodlagos' : 'text-szoveg-halk [&_b]:font-medium [&_b]:text-szoveg'}`}>{felirat}</span>
    </div>
  );
}
